export const countryOptions = [
  { label: "Afghanistan (+93)", value: "+93", flag: '🇦🇫', iso: 'AF' },
  { label: "Albania (+355)", value: "+355", flag: '🇦🇱', iso: 'AL' },
  { label: "Algeria (+213)", value: "+213", flag: '🇩🇿', iso: 'DZ' },
  { label: "Andorra (+376)", value: "+376", flag: '🇦🇩', iso: 'AD' },
  { label: "Angola (+244)", value: "+244", flag: '🇦🇴', iso: 'AO' },
  { label: "Antigua & Barbuda (+1-268)", value: "+1-268", flag: '🇦🇬', iso: 'AG' },
  { label: "Argentina (+54)", value: "+54", flag: '🇦🇷', iso: 'AR' },
  { label: "Armenia (+374)", value: "+374", flag: '🇦🇲', iso: 'AM' },
  { label: "Australia (+61)", value: "+61", flag: '🇦🇺', iso: 'AU' },
  { label: "Austria (+43)", value: "+43", flag: '🇦🇹', iso: 'AT' },
  { label: "Azerbaijan (+994)", value: "+994", flag: '🇦🇿', iso: 'AZ' },
  { label: "Bahamas (+1-242)", value: "+1-242", flag: '🇧🇸', iso: 'BS' },
  { label: "Bahrain (+973)", value: "+973", flag: '🇧🇭', iso: 'BH' },
  { label: "Bangladesh (+880)", value: "+880", flag: '🇧🇩', iso: 'BD' },
  { label: "Barbados (+1-246)", value: "+1-246", flag: '🇧🇧', iso: 'BB' },
  { label: "Belarus (+375)", value: "+375", flag: '🇧🇾', iso: 'BY' },
  { label: "Belgium (+32)", value: "+32", flag: '🇧🇪', iso: 'BE' },
  { label: "Belize (+501)", value: "+501", flag: '🇧🇿', iso: 'BZ' },
  { label: "Benin (+229)", value: "+229", flag: '🇧🇯', iso: 'BJ' },
  { label: "Bhutan (+975)", value: "+975", flag: '🇧🇹', iso: 'BT' },
  { label: "Bolivia (+591)", value: "+591", flag: '🇧🇴', iso: 'BO' },
  { label: "Bosnia & Herzegovina (+387)", value: "+387", flag: '🇧🇦', iso: 'BA' },
  { label: "Botswana (+267)", value: "+267", flag: '🇧🇼', iso: 'BW' },
  { label: "Brazil (+55)", value: "+55", flag: '🇧🇷', iso: 'BR' },
  { label: "Brunei (+673)", value: "+673", flag: '🇧🇳', iso: 'BN' },
  { label: "Bulgaria (+359)", value: "+359", flag: '🇧🇬', iso: 'BG' },
  { label: "Burkina Faso (+226)", value: "+226", flag: '🇧🇫', iso: 'BF' },
  { label: "Burundi (+257)", value: "+257", flag: '🇧🇮', iso: 'BI' },
  { label: "Cambodia (+855)", value: "+855", flag: '🇰🇭', iso: 'KH' },
  { label: "Cameroon (+237)", value: "+237", flag: '🇨🇲', iso: 'CM' },
  { label: "Canada (+1)", value: "+1", flag: '🇨🇦', iso: 'CA' },
  { label: "Cape Verde (+238)", value: "+238", flag: '🇨🇻', iso: 'CV' },
  { label: "Central African Republic (+236)", value: "+236", flag: '🇨🇫', iso: 'CF' },
  { label: "Chad (+235)", value: "+235", flag: '🇹🇩', iso: 'TD' },
  { label: "Chile (+56)", value: "+56", flag: '🇨🇱', iso: 'CL' },
  { label: "China (+86)", value: "+86", flag: '🇨🇳', iso: 'CN' },
  { label: "Colombia (+57)", value: "+57", flag: '🇨🇴', iso: 'CO' },
  { label: "Comoros (+269)", value: "+269", flag: '🇰🇲', iso: 'KM' },
  { label: "Congo (DRC) (+243)", value: "+243", flag: '🇨🇩', iso: 'CD' },
  { label: "Congo (+242)", value: "+242", flag: '🇨🇬', iso: 'CG' },
  { label: "Costa Rica (+506)", value: "+506", flag: '🇨🇷', iso: 'CR' },
  { label: "Croatia (+385)", value: "+385", flag: '🇭🇷', iso: 'HR' },
  { label: "Cuba (+53)", value: "+53", flag: '🇨🇺', iso: 'CU' },
  { label: "Cyprus (+357)", value: "+357", flag: '🇨🇾', iso: 'CY' },
  { label: "Czech Republic (+420)", value: "+420", flag: '🇨🇿', iso: 'CZ' },
  { label: "Denmark (+45)", value: "+45", flag: '🇩🇰', iso: 'DK' },
  { label: "Djibouti (+253)", value: "+253", flag: '🇩🇯', iso: 'DJ' },
  { label: "Dominica (+1-767)", value: "+1-767", flag: '🇩🇲', iso: 'DM' },
  { label: "Dominican Republic (+1-809)", value: "+1-809", flag: '🇩🇴', iso: 'DO' },
  { label: "East Timor (+670)", value: "+670", flag: '🇹🇱', iso: 'TL' },
  { label: "Ecuador (+593)", value: "+593", flag: '🇪🇨', iso: 'EC' },
  { label: "Egypt (+20)", value: "+20", flag: '🇪🇬', iso: 'EG' },
  { label: "El Salvador (+503)", value: "+503", flag: '🇸🇻', iso: 'SV' },
  { label: "Equatorial Guinea (+240)", value: "+240", flag: '🇬🇶', iso: 'GQ' },
  { label: "Eritrea (+291)", value: "+291", flag: '🇪🇷', iso: 'ER' },
  { label: "Estonia (+372)", value: "+372", flag: '🇪🇪', iso: 'EE' },
  { label: "Ethiopia (+251)", value: "+251", flag: '🇪🇹', iso: 'ET' },
  { label: "Fiji (+679)", value: "+679", flag: '🇫🇯', iso: 'FJ' },
  { label: "Finland (+358)", value: "+358", flag: '🇫🇮', iso: 'FI' },
  { label: "France (+33)", value: "+33", flag: '🇫🇷', iso: 'FR' },
  { label: "Gabon (+241)", value: "+241", flag: '🇬🇦', iso: 'GA' },
  { label: "Gambia (+220)", value: "+220", flag: '🇬🇲', iso: 'GM' },
  { label: "Georgia (+995)", value: "+995", flag: '🇬🇪', iso: 'GE' },
  { label: "Germany (+49)", value: "+49", flag: '🇩🇪', iso: 'DE' },
  { label: "Ghana (+233)", value: "+233", flag: '🇬🇭', iso: 'GH' },
  { label: "Greece (+30)", value: "+30", flag: '🇬🇷', iso: 'GR' },
  { label: "Grenada (+1-473)", value: "+1-473", flag: '🇬🇩', iso: 'GD' },
  { label: "Guatemala (+502)", value: "+502", flag: '🇬🇹', iso: 'GT' },
  { label: "Guinea (+224)", value: "+224", flag: '🇬🇳', iso: 'GN' },
  { label: "Guinea-Bissau (+245)", value: "+245", flag: '🇬🇼', iso: 'GW' },
  { label: "Guyana (+592)", value: "+592", flag: '🇬🇾', iso: 'GY' },
  { label: "Haiti (+509)", value: "+509", flag: '🇭🇹', iso: 'HT' },
  { label: "Honduras (+504)", value: "+504", flag: '🇭🇳', iso: 'HN' },
  { label: "Hungary (+36)", value: "+36", flag: '🇭🇺', iso: 'HU' },
  { label: "Iceland (+354)", value: "+354", flag: '🇮🇸', iso: 'IS' },
  { label: "India (+91)", value: "+91", flag: '🇮🇳', iso: 'IN' },
  { label: "Indonesia (+62)", value: "+62", flag: '🇮🇩', iso: 'ID' },
  { label: "Iran (+98)", value: "+98", flag: '🇮🇷', iso: 'IR' },
  { label: "Iraq (+964)", value: "+964", flag: '🇮🇶', iso: 'IQ' },
  { label: "Ireland (+353)", value: "+353", flag: '🇮🇪', iso: 'IE' },
  { label: "Israel (+972)", value: "+972", flag: '🇮🇱', iso: 'IL' },
  { label: "Italy (+39)", value: "+39", flag: '🇮🇹', iso: 'IT' },
  { label: "Cote d'Ivoire (+225)", value: "+225", flag: '🇨🇮', iso: 'CI' },
  { label: "Jamaica (+1-876)", value: "+1-876", flag: '🇯🇲', iso: 'JM' },
  { label: "Japan (+81)", value: "+81", flag: '🇯🇵', iso: 'JP' },
  { label: "Jordan (+962)", value: "+962", flag: '🇯🇴', iso: 'JO' },
  { label: "Kazakhstan (+7)", value: "+7", flag: '🇰🇿', iso: 'KZ' },
  { label: "Kenya (+254)", value: "+254", flag: '🇰🇪', iso: 'KE' },
  { label: "Kiribati (+686)", value: "+686", flag: '🇰🇮', iso: 'KI' },
  { label: "North Korea (+850)", value: "+850", flag: '🇰🇵', iso: 'KP' },
  { label: "South Korea (+82)", value: "+82", flag: '🇰🇷', iso: 'KR' },
  { label: "Kuwait (+965)", value: "+965", flag: '🇰🇼', iso: 'KW' },
  { label: "Kyrgyzstan (+996)", value: "+996", flag: '🇰🇬', iso: 'KG' },
  { label: "Laos (+856)", value: "+856", flag: '🇱🇦', iso: 'LA' },
  { label: "Latvia (+371)", value: "+371", flag: '🇱🇻', iso: 'LV' },
  { label: "Lebanon (+961)", value: "+961", flag: '🇱🇧', iso: 'LB' },
  { label: "Lesotho (+266)", value: "+266", flag: '🇱🇸', iso: 'LS' },
  { label: "Liberia (+231)", value: "+231", flag: '🇱🇷', iso: 'LR' },
  { label: "Libya (+218)", value: "+218", flag: '🇱🇾', iso: 'LY' },
  { label: "Liechtenstein (+423)", value: "+423", flag: '🇱🇮', iso: 'LI' },
  { label: "Lithuania (+370)", value: "+370", flag: '🇱🇹', iso: 'LT' },
  { label: "Luxembourg (+352)", value: "+352", flag: '🇱🇺', iso: 'LU' },
  { label: "North Macedonia (+389)", value: "+389", flag: '🇲🇰', iso: 'MK' },
  { label: "Madagascar (+261)", value: "+261", flag: '🇲🇬', iso: 'MG' },
  { label: "Malawi (+265)", value: "+265", flag: '🇲🇼', iso: 'MW' },
  { label: "Malaysia (+60)", value: "+60", flag: '🇲🇾', iso: 'MY' },
  { label: "Maldives (+960)", value: "+960", flag: '🇲🇻', iso: 'MV' },
  { label: "Mali (+223)", value: "+223", flag: '🇲🇱', iso: 'ML' },
  { label: "Malta (+356)", value: "+356", flag: '🇲🇹', iso: 'MT' },
  { label: "Marshall Islands (+692)", value: "+692", flag: '🇲🇭', iso: 'MH' },
  { label: "Mauritania (+222)", value: "+222", flag: '🇲🇷', iso: 'MR' },
  { label: "Mauritius (+230)", value: "+230", flag: '🇲🇺', iso: 'MU' },
  { label: "Mexico (+52)", value: "+52", flag: '🇲🇽', iso: 'MX' },
  { label: "Micronesia (+691)", value: "+691", flag: '🇫🇲', iso: 'FM' },
  { label: "Moldova (+373)", value: "+373", flag: '🇲🇩', iso: 'MD' },
  { label: "Monaco (+377)", value: "+377", flag: '🇲🇨', iso: 'MC' },
  { label: "Mongolia (+976)", value: "+976", flag: '🇲🇳', iso: 'MN' },
  { label: "Montenegro (+382)", value: "+382", flag: '🇲🇪', iso: 'ME' },
  { label: "Morocco (+212)", value: "+212", flag: '🇲🇦', iso: 'MA' },
  { label: "Mozambique (+258)", value: "+258", flag: '🇲🇿', iso: 'MZ' },
  { label: "Myanmar (+95)", value: "+95", flag: '🇲🇲', iso: 'MM' },
  { label: "Namibia (+264)", value: "+264", flag: '🇳🇦', iso: 'NA' },
  { label: "Nauru (+674)", value: "+674", flag: '🇳🇷', iso: 'NR' },
  { label: "Nepal (+977)", value: "+977", flag: '🇳🇵', iso: 'NP' },
  { label: "Netherlands (+31)", value: "+31", flag: '🇳🇱', iso: 'NL' },
  { label: "New Zealand (+64)", value: "+64", flag: '🇳🇿', iso: 'NZ' },
  { label: "Nicaragua (+505)", value: "+505", flag: '🇳🇮', iso: 'NI' },
  { label: "Niger (+227)", value: "+227", flag: '🇳🇪', iso: 'NE' },
  { label: "Nigeria (+234)", value: "+234", flag: '🇳🇬', iso: 'NG' },
  { label: "Norway (+47)", value: "+47", flag: '🇳🇴', iso: 'NO' },
  { label: "Oman (+968)", value: "+968", flag: '🇴🇲', iso: 'OM' },
  { label: "Pakistan (+92)", value: "+92", flag: '🇵🇰', iso: 'PK' },
  { label: "Palau (+680)", value: "+680", flag: '🇵🇼', iso: 'PW' },
  { label: "Panama (+507)", value: "+507", flag: '🇵🇦', iso: 'PA' },
  { label: "Papua New Guinea (+675)", value: "+675", flag: '🇵🇬', iso: 'PG' },
  { label: "Paraguay (+595)", value: "+595", flag: '🇵🇾', iso: 'PY' },
  { label: "Peru (+51)", value: "+51", flag: '🇵🇪', iso: 'PE' },
  { label: "Philippines (+63)", value: "+63", flag: '🇵🇭', iso: 'PH' },
  { label: "Poland (+48)", value: "+48", flag: '🇵🇱', iso: 'PL' },
  { label: "Portugal (+351)", value: "+351", flag: '🇵🇹', iso: 'PT' },
  { label: "Qatar (+974)", value: "+974", flag: '🇶🇦', iso: 'QA' },
  { label: "Romania (+40)", value: "+40", flag: '🇷🇴', iso: 'RO' },
  { label: "Russia (+7)", value: "+7", flag: '🇷🇺', iso: 'RU' },
  { label: "Rwanda (+250)", value: "+250", flag: '🇷🇼', iso: 'RW' },
  { label: "St. Kitts & Nevis (+1-869)", value: "+1-869", flag: '🇰🇳', iso: 'KN' },
  { label: "St. Lucia (+1-758)", value: "+1-758", flag: '🇱🇨', iso: 'LC' },
  { label: "St. Vincent & Grenadines (+1-784)", value: "+1-784", flag: '🇻🇨', iso: 'VC' },
  { label: "Samoa (+685)", value: "+685", flag: '🇼🇸', iso: 'WS' },
  { label: "San Marino (+378)", value: "+378", flag: '🇸🇲', iso: 'SM' },
  { label: "Sao Tome & Principe (+239)", value: "+239", flag: '🇸🇹', iso: 'ST' },
  { label: "Saudi Arabia (+966)", value: "+966", flag: '🇸🇦', iso: 'SA' },
  { label: "Senegal (+221)", value: "+221", flag: '🇸🇳', iso: 'SN' },
  { label: "Serbia (+381)", value: "+381", flag: '🇷🇸', iso: 'RS' },
  { label: "Seychelles (+248)", value: "+248", flag: '🇸🇨', iso: 'SC' },
  { label: "Sierra Leone (+232)", value: "+232", flag: '🇸🇱', iso: 'SL' },
  { label: "Singapore (+65)", value: "+65", flag: '🇸🇬', iso: 'SG' },
  { label: "Slovakia (+421)", value: "+421", flag: '🇸🇰', iso: 'SK' },
  { label: "Slovenia (+386)", value: "+386", flag: '🇸🇮', iso: 'SI' },
  { label: "Solomon Islands (+677)", value: "+677", flag: '🇸🇧', iso: 'SB' },
  { label: "Somalia (+252)", value: "+252", flag: '🇸🇴', iso: 'SO' },
  { label: "South Africa (+27)", value: "+27", flag: '🇿🇦', iso: 'ZA' },
  { label: "Spain (+34)", value: "+34", flag: '🇪🇸', iso: 'ES' },
  { label: "Sri Lanka (+94)", value: "+94", flag: '🇱🇰', iso: 'LK' },
  { label: "Sudan (+249)", value: "+249", flag: '🇸🇩', iso: 'SD' },
  { label: "Suriname (+597)", value: "+597", flag: '🇸🇷', iso: 'SR' },
  { label: "Eswatini (+268)", value: "+268", flag: '🇸🇿', iso: 'SZ' },
  { label: "Sweden (+46)", value: "+46", flag: '🇸🇪', iso: 'SE' },
  { label: "Switzerland (+41)", value: "+41", flag: '🇨🇭', iso: 'CH' },
  { label: "Syria (+963)", value: "+963", flag: '🇸🇾', iso: 'SY' },
  { label: "Taiwan (+886)", value: "+886", flag: '🇹🇼', iso: 'TW' },
  { label: "Tajikistan (+992)", value: "+992", flag: '🇹🇯', iso: 'TJ' },
  { label: "Tanzania (+255)", value: "+255", flag: '🇹🇿', iso: 'TZ' },
  { label: "Thailand (+66)", value: "+66", flag: '🇹🇭', iso: 'TH' },
  { label: "Togo (+228)", value: "+228", flag: '🇹🇬', iso: 'TG' },
  { label: "Tonga (+676)", value: "+676", flag: '🇹🇴', iso: 'TO' },
  { label: "Trinidad & Tobago (+1-868)", value: "+1-868", flag: '🇹🇹', iso: 'TT' },
  { label: "Tunisia (+216)", value: "+216", flag: '🇹🇳', iso: 'TN' },
  { label: "Turkey (+90)", value: "+90", flag: '🇹🇷', iso: 'TR' },
  { label: "Turkmenistan (+993)", value: "+993", flag: '🇹🇲', iso: 'TM' },
  { label: "Tuvalu (+688)", value: "+688", flag: '🇹🇻', iso: 'TV' },
  { label: "Uganda (+256)", value: "+256", flag: '🇺🇬', iso: 'UG' },
  { label: "Ukraine (+380)", value: "+380", flag: '🇺🇦', iso: 'UA' },
  { label: "UAE (+971)", value: "+971", flag: '🇦🇪', iso: 'AE' },
  { label: "United Kingdom (+44)", value: "+44", flag: '🇬🇧', iso: 'GB' },
  { label: "United States (+1)", value: "+1", flag: '🇺🇸', iso: 'US' },
  { label: "Uruguay (+598)", value: "+598", flag: '🇺🇾', iso: 'UY' },
  { label: "Uzbekistan (+998)", value: "+998", flag: '🇺🇿', iso: 'UZ' },
  { label: "Vanuatu (+678)", value: "+678", flag: '🇻🇺', iso: 'VU' },
  { label: "Vatican (+379)", value: "+379", flag: '🇻🇦', iso: 'VA' },
  { label: "Venezuela (+58)", value: "+58", flag: '🇻🇪', iso: 'VE' },
  { label: "Vietnam (+84)", value: "+84", flag: '🇻🇳', iso: 'VN' },
  { label: "Yemen (+967)", value: "+967", flag: '🇾🇪', iso: 'YE' },
  { label: "Zambia (+260)", value: "+260", flag: '🇿🇲', iso: 'ZM' },
  { label: "Zimbabwe (+263)", value: "+263", flag: '🇿🇼', iso: 'ZW' }
];
